import React from 'react';
import { Chip } from '@mui/material';

export const ACTIVE_STATUSES = 'PENDING,PREAPPROVE,APPROVE_1,APPROVE_2,APPROVE,PREPARE';

export const PAYMENT_STATUS_MAP = {
  SUCCESS: { label: 'จ่ายแล้ว', bg: '#dcfce7', color: '#15803d' },
  PARTIAL: { label: 'จ่ายบางส่วน', bg: '#dbeafe', color: '#1d4ed8' },
  PENDING: { label: 'รอดำเนินการ', bg: '#fff3cd', color: '#92400e' },
};

export const statusChip = (status) => {
  const cfg = PAYMENT_STATUS_MAP[status] || PAYMENT_STATUS_MAP.PENDING;
  return (
    <Chip
      label={cfg.label}
      size="small"
      sx={{ fontWeight: 700, fontSize: '0.7rem', backgroundColor: cfg.bg, color: cfg.color, border: 'none' }}
    />
  );
};

export const EXP_STATUS_MAP = {
  PENDING: { label: 'Pending', bg: '#f3f4f6', color: '#6b7280' },
  PREAPPROVE: { label: 'Pre-Approved', bg: '#ede9fe', color: '#7c3aed' },
  APPROVE_1: { label: '1st Approved', bg: '#dbeafe', color: '#2563eb' },
  APPROVE_2: { label: '2nd Approved', bg: '#cffafe', color: '#0891b2' },
  APPROVE: { label: '3rd Approved', bg: '#fef3c7', color: '#d97706' },
  PREPARE: { label: 'Prepared', bg: '#e0f2fe', color: '#0284c7' },
  SUCCESS: { label: 'Success', bg: '#dcfce7', color: '#15803d' },
  REJECT: { label: 'Rejected', bg: '#fee2e2', color: '#dc2626' },
  HOLD: { label: 'Hold', bg: '#fee2e2', color: '#dc2626' },
};

export const STATUS_GROUPS = [
  { key: 'PENDING', label: 'รออนุมัติ', statuses: ['PENDING', 'PREAPPROVE', 'APPROVE_1', 'APPROVE_2'], color: '#92400e', hover: '#fff3cd' },
  { key: 'APPROVE', label: 'อนุมัติแล้ว', statuses: ['APPROVE'], color: '#15803d', hover: '#dcfce7' },
  { key: 'PREPARE', label: 'เตรียมจ่าย', statuses: ['PREPARE'], color: '#1d4ed8', hover: '#dbeafe' },
  { key: 'SUCCESS', label: 'จ่ายแล้ว', statuses: ['SUCCESS'], color: '#6b21a8', hover: '#f3e8ff' },
];
